export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';

export interface searchState {
    search_text: string | number
}
export interface searchAction{
    type: typeof SET_SEARCH_TEXT,
    payload:number
}